import { useEffect, useState } from "react";

const mobileBreakpoint = 769;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < mobileBreakpoint);
  const handleResize = () => {
    setIsMobile(window.innerWidth < mobileBreakpoint);
  };

  window.addEventListener("resize", handleResize);

  useEffect(() => {
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
